import { Component,  EventEmitter,  Input, OnInit, Output } from '@angular/core';
import { BrandingImageType, JoiBrandImage } from 'globals/store/publish.data';
import { createId } from 'globals/helpers/helpers';
import { JoiAccount } from 'globals/store/accounts.data';
import { Wrapper } from '../wrapper.component';
import { ImageUploaderResult } from 'globals/store/share.data';
import { CommonModule } from '@angular/common';
import { BrandImageTextAdderComponent } from './brand-image-text-adder.component';
import { BrandingControlsWrapperComponent } from './brand-controls-wrapper.component';
import { JoiInputComponent } from '../joi-input/joi-input.component';


@Component({
    selector: 'brand-image',
    template: `
<branding-controls-wrapper *ngIf="!readOnly"
  [selected]="selected"
  [isAccountDefault]="isAccountDefault"
  [showEdit]="true"
  [editing]="editing"
  [canRemove]="true"
  [onAccount]="onAccount"
  [deleteTitle]="deleteTitle" 
  [deleteText]="deleteText" 
  (delete)="delete.emit()"
  (setAsAccountDefault)="setAsAccountDefault.emit()"
  (unselect)="unselect.emit()"
  (select)="select.emit()"
  (edit)="edit.emit($event)"
>
  <joi-input class="big-title"
    [italicPlaceholder]="true"  
    [type]="'textarea'" 
    [disabled]="!editing && !onAccount" 
    [(model)]="template.name" [placeholder]="'Template name...'" (joiChange)="update.emit()"
  ></joi-input>
  <div class="upload-actions" *ngIf="!readOnly && !!editing">
    <brand-image-text-adder 
      [maxMegs]="2" 
      [width]="1400" 
      [height]="230"
      [accountId]="account.id"
      [imageType]="'header'"
      [uniqueFormIdentifier]="'desktop'"
      [uploadText]="'UPLOAD <u>DESKTOP</u> ' + (type === 'headers' ? 'HEADER' :  'FOOTER') + ' IMAGE'"
      (addImage)="addImage($event, 'desktop')"
    ></brand-image-text-adder>
    <brand-image-text-adder 
      [maxMegs]="1" 
      [width]="360" 
      [height]="120"
      [imageType]="'header'"
      [accountId]="account.id"
      [uniqueFormIdentifier]="'mobile'"
      [uploadText]="'UPLOAD <u>MOBILE</u> ' + (type === 'headers' ? 'HEADER' : 'FOOTER') + ' IMAGE'"
      (addImage)="addImage($event, 'mobile')"
    ></brand-image-text-adder>
  </div>
  <ng-container *ngTemplateOutlet="body"></ng-container>
</branding-controls-wrapper>
<ng-container *ngIf="!!readOnly"><ng-container *ngTemplateOutlet="body"></ng-container></ng-container>

<ng-template #body>
  <div class="images" *ngIf="!!template.link || !!template.mobileLink">
    <div class="image desktopImage" *ngIf="!!template.link">
      <div class="image-title">Desktop</div>
      <img [src]="template.link" />
    </div>
    <div class="image mobileImage" *ngIf="!!template.mobileLink">
      <div class="image-title">Mobile</div>
      <img [src]="template.mobileLink"/>
    </div>
  </div>
  <div class="empty" *ngIf="!template.link && !template.mobileLink">
    No images in this template
  </div>
</ng-template>
`,
    styles: [`
    brand-image-text-adder { margin: 10px 20px 10px 0; }
    .upload-actions { display: flex; flex-wrap: wrap; justify-content: space-around; margin-bottom: 20px; } 
    icon.edit { cursor: pointer; }
    .images { display: flex; justify-content: space-around; max-width: fit-content; margin: 0 auto 15px; }
    .image { display: flex; flex-direction: column; }
    .image.desktopImage { max-width: calc(80% - 5px); }
    .image.mobileImage { max-width: calc(20% - 5px); }
    .image-title, .empty { color: var(--light-text); font-size: 11px; }
    .big-title { margin: 10px 0; }
  `],
    styleUrls: ['./branding-card-controls.scss'],
    standalone: true,
    imports: [CommonModule, BrandImageTextAdderComponent, BrandingControlsWrapperComponent, JoiInputComponent],
})
export class BrandImageComponent extends Wrapper<BrandImageComponent> implements OnInit {
  @Input() editing: boolean
  @Input() readOnly: boolean
  @Input() account: Partial<JoiAccount>
  @Input() template: JoiBrandImage
  @Input() type: BrandingImageType
  @Input() selected: boolean
  @Input() isAccountDefault: boolean
  @Input() onAccount = false
    
  @Output() update: EventEmitter<void> = new EventEmitter()
  @Output() edit: EventEmitter<boolean> = new EventEmitter()
  @Output() delete: EventEmitter<void> = new EventEmitter()
  @Output() select: EventEmitter<void> = new EventEmitter()
  @Output() unselect: EventEmitter<void> = new EventEmitter()
  @Output() setAsAccountDefault: EventEmitter<void> = new EventEmitter()

  imageId = createId()
  mobileId = createId()
  deleteTitle: string
  deleteText: string

  ngOnInit() {
    this.deleteTitle = `Delete ${ this.type === 'headers' ? 'header' : this.type === 'footers' ? 'footer' : 'event list thumbnail'} image${this.template.mobileLink && this.template.link ? 's' : ''}?`
  }

  addImage(result: ImageUploaderResult, type: 'desktop' | 'mobile') {
    if (type === 'desktop') this.template.link = result.photoUrl
    else this.template.mobileLink = result.photoUrl
    this.imageId = createId()
    this.mobileId = createId()
    this.update.emit()
  }
}